import styled from 'styled-components';

export default styled.span`
  font-size: ${(props) => (props.fontSize ? props.fontSize : 'inherit')};
  font-weight: bold;
  color: ${(props) => props.theme.colors[props.type]};
`;
